export default {"src":"/_next/static/image/public/assets/icons/shorten.412f4909c00170ae14d84ddac2754233.svg","height":32,"width":32};